import { Component, OnDestroy, OnInit } from '@angular/core';
import { Uom1Service } from './uom1.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SetupService } from '../setup.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ObjectNames, Status, Severity, Answer } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { AppMainComponent } from 'src/app/app.main.component';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';

@Component({
  selector: 'app-uom1',
  templateUrl: './uom1.component.html',
  styleUrls: ['./uom1.component.scss']
})
export class Uom1Component implements OnInit, OnDestroy {

  UOMForm: FormGroup;
  addNewForm: FormGroup;
  unitOfConversion: any = [];
  allMeasurements = [];
  measurements = [];
  allBaseUom = [];
  baseUomDD = [];
  allRelatedUom = [];
  relatedUomDD = [];
  addEditUOMHeader: string;
  displayAddUOM: boolean = false;
  displayAddUOM2: boolean = false;
  displayAddOtherUOM: boolean = false;
  UOMTypes = [];
  conversionLists = [];
  headerCheck: boolean = false;
  isEdit: boolean = false;
  uomConstants = ObjectNames.productConstants;
  answertypeConstants = Answer;
  statusConstants = Status;
  relatedUOMName: string;
  baseUOMName: string;
  addrelatedBaseUOM: boolean = false;
  displayUOMAvailability: boolean = false;
  associatedUOM: string;
  types = [];
  action: string='';
  selectedType;

  constructor(private uomService: Uom1Service, private confirmationService: ConfirmationService, private messageService: MessageService,
    private setupService: SetupService, private fb: FormBuilder, private titlecasePipe: TitleCasePipe,
    private app: AppMainComponent, private addYearPipe: AddYearPipe) { }

  ngOnInit(): void {
    this.UOMForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      code: [''],
      name: [''],
      description: [''],
      baseUOMId: [],
      value: [''],
      relatedBaseUOMId: [''],
      organizationId: [this.app.companyId],
      categoryId: [''],
      category: [null],
      statusId: [true],
      isDefault: [false],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.addYearPipe.transform(new Date())],
      isEnable: [true]
    });

    this.addNewForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      code: ['', Validators.required],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      organizationId: [this.app.companyId],
      categoryId: ['']
    })
    this.setupService.getUom().subscribe(uom => {
      if (uom) {
        this.showAddUOM();
      }
    })
    this.getInventoryGroups();
  }

  getInventoryGroups() {
    this.uomService.getInventoryGroupList().subscribe(groups => {
      const uomGroup = groups.filter(s => s.name == ObjectNames.productConstants.UOMPropertyName)[0];
      this.getUOMCategory(uomGroup.id);
    });
  }

  getUOMCategory(groupId) {
    this.uomService.getInventoryCategory(groupId).subscribe(types => {
      this.UOMTypes = types;
      let all = { id: 0, name: "All", statusId: 1 }
      this.types = JSON.parse(JSON.stringify(types));
      this.types.push(all)
      this.selectedType = this.types.find(ele => ele.name == 'Count');
      this.loadUOM();
    });
  }

  createItem(value) {
    return {
      id: value.relatedBaseUOMId.id,
      name: value.relatedBaseUOMId.name,
      code: value.relatedBaseUOMId.code,
      value: value.value
    };
  }

  addItem(value): void {
    this.unitOfConversion.push(this.createItem(value));
    this.conversionLists = this.unitOfConversion;
    this.UOMForm.controls['value'].reset();
    this.UOMForm.controls['relatedBaseUOMId'].reset();
    const index = this.relatedUomDD?.indexOf(value.relatedBaseUOMId);
    this.relatedUomDD = this.relatedUomDD?.filter((data, idx) => idx !== index);

  }

  deleteFormula(index) {
    this.conversionLists.splice(index, 1);
  }

  getBaseUOMByType(event, parentId, type?) {
    const typeId = (type ? event : event.value.id);
    this.uomService.getBaseUOM(typeId, parentId, 0).subscribe(baseUOM => {
      this.baseUomDD = baseUOM;
    });
  }

  addOtherUom(value) {
    if (value.value.name == ObjectNames.productConstants.AddNewTitle) {
      this.addEditUOMHeader = ObjectNames.productConstants.AddUOMTitle;
      this.displayAddOtherUOM = true;
      this.addNewForm = this.fb.group({
        id: [0],
        createdSource: [this.app.userIP],
        updatedSource: [this.app.userIP],
        createdBy: [this.app.userId],
        updatedBy: [this.app.userId],
        createdDate: [new Date().toISOString()],
        updatedDate: [new Date().toISOString()],
        code: ['', Validators.required],
        name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
        description: [''],
        organizationId: [this.app.companyId],
        categoryId: ['']
      })
    }
  }

  saveOtherUom(value) {
    value.categoryId = this.UOMForm.controls['categoryId'].value.id;
    this.uomService.addNewBaseUOM(value).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'UOM Added successfully...' });
      this.getBaseUOMByType(value.categoryId, 0, ObjectNames.productConstants.NewType);
      this.displayAddOtherUOM = false;
    }).catch(() => {
      this.displayAddOtherUOM = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  loadUOM() {
    this.uomService.getAllMeasurements().subscribe(m => {
      const removeElement = m?.find(uom => uom.name == ObjectNames.productConstants.AddNewTitle);
      const index = m?.indexOf(removeElement);
      if (index != -1) {
        m?.splice(index, 1);
      }
      this.allMeasurements = m;
      if (this.selectedType?.name == 'All') {
        this.measurements = this.allMeasurements;
      } else {
        this.measurements = this.allMeasurements.filter(e => e.category.name == this.selectedType.name);
      }
    });
  }

  prepareUOMForm(){
    this.UOMForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      code: [''],
      name: [''],
      description: [''],
      baseUOMId: [],
      value: [''],
      relatedBaseUOMId: [''],
      organizationId: [this.app.companyId],
      categoryId: ['', [Validators.required]],
      category: [null],
      statusId: [true],
      isDefault: [false],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.addYearPipe.transform(new Date())],
      isEnable: [true]
    });
  }

  showAddUOM() {
    this.addEditUOMHeader = ObjectNames.productConstants.AddUOMTitle;
    this.isEdit = false;
    this.addrelatedBaseUOM = false;
    this.prepareUOMForm();
    this.displayAddUOM = true;
  }

  showAddUOM2(c) {
    this.isEdit = false;
    this.conversionLists = [];
    this.unitOfConversion = [];
    this.displayAddUOM = false;
    this.addrelatedBaseUOM = false;
    this.prepareUOMForm();
    this.UOMForm.patchValue(c);
    this.displayAddUOM2 = true;
    this.UOMForm.controls['statusId'].setValue(c.statusId == Status.ACTIVE);
    this.uomService.getBaseUOM(c.categoryId.id, 1, 0).subscribe(baseUOM => {
      this.relatedUomDD = baseUOM;
      this.relatedUomDD?.splice(this.relatedUomDD.findIndex((i) => {
        return i.id === c.baseUOMId?.id;
      }), 1);
      this.relatedUomDD?.splice(this.relatedUomDD.findIndex((i) => {
        return i.name === ObjectNames.productConstants.AddNewTitle;
      }), 1);
    });

  }

  backUOM() {
    this.displayAddUOM2 = false;
    this.displayAddUOM = true;
  }

  showEditUOM(value) {
    this.prepareUOMForm();
    this.displayAddUOM2 = true;
    this.addrelatedBaseUOM = false;
    this.addEditUOMHeader = ObjectNames.productConstants.EditUOMTitle;
    this.isEdit = true;
    this.UOMForm.patchValue(value);
    this.UOMForm.controls['statusId'].setValue(value.statusId === Status.ACTIVE);
    const filteredCategory = this.UOMTypes.filter(data => data.id == value.categoryId)[0];
    this.UOMForm.controls['categoryId'].setValue(filteredCategory);
    this.baseUOMName = value.baseUOMName;
    this.relatedUOMName = value.name;
  }

  saveUOM(value) {
    const finalReq = [];
    if (!this.addrelatedBaseUOM && !this.isEdit) {
      finalReq.push(
        {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          name: value.baseUOMId.name,
          description: value.baseUOMId.name,
          organizationId: this.app.companyId,
          code: value.baseUOMId.code,
          categoryId: value.categoryId.id,
          baseUOMId: 0,
          relatedBaseUOMId: value.baseUOMId.id,
          value: 1,
          statusId: (value.statusId ? Status.ACTIVE : Status.INACTIVE),
          isDefault: false,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addYearPipe.transform(new Date()),
          isParent: true,
          isEnable: true
        }
      );

      this.conversionLists.forEach(element => {
        const req = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          name: element.name,
          description: element.name,
          organizationId: this.app.companyId,
          code: element.code,
          categoryId: value.categoryId.id,
          baseUOMId: 0,
          relatedBaseUOMId: element.id,
          value: element.value,
          statusId: (value.statusId ? Status.ACTIVE : Status.INACTIVE),
          isDefault: false,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addYearPipe.transform(new Date()),
          isParent: false,
          isEnable: true
        }
        finalReq.push(req)
      });
    } else {
      this.conversionLists.forEach(element => {
        const req = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          name: element.name,
          description: element.name,
          organizationId: this.app.companyId,
          code: element.code,
          categoryId: value.categoryId.id,
          baseUOMId: value.id,
          relatedBaseUOMId: element.id,
          value: element.value,
          statusId: (value.statusId ? Status.ACTIVE : Status.INACTIVE),
          isDefault: false,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addYearPipe.transform(new Date()),
          isParent: false,
          isEnable: true
        }
        finalReq.push(req)
      });
    }
    if (!this.isEdit) {
      this.uomService.addUOM(finalReq).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'UOM Added successfully...' });
        this.loadUOM();
        this.displayAddUOM2 = false;
      }).catch(() => {
        this.displayAddUOM2 = false;
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    } else {
      value.categoryId = value.categoryId.id;
      value.statusId = (value.statusId ? Status.ACTIVE : Status.INACTIVE);
      value.updatedBy = this.app.userId;
      value.updatedDate = new Date().toISOString();
      value.updatedSource = this.app.userIP;
      this.updateRelatedUOM(value);
    }
  }

  updateRelatedUOM(value, action?) {
    this.uomService.updateUOM(value).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'UOM Updated successfully...' });
       if(action=='default'){
         for(let unit of this.allMeasurements){
          if(value.id==unit.id){
           unit.isDefault = true;
           unit.isEnable = true;
          }else{
            unit.isDefault = false;
          }
         }
       }else if(action=='enabled'){
          for(let unit of this.allMeasurements){
            if(value.isEnable && unit.id==value.id){
             unit.isEnable = true;
            }else if(!value.isEnable  && unit.id==value.id){
              unit.isEnable = false;
             }
        }  
       }else{
        this.loadUOM();
       }
      this.displayAddUOM2 = false;
    }).catch(() => {
      this.displayAddUOM2 = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  checkUOMProduct() {
    if (this.isEdit && this.UOMForm.controls['statusId'].value == false) {
      this.uomService.checkAssociateUOM(this.UOMForm.controls['id'].value).subscribe(check => {
        if (check.item1) {
          this.displayUOMAvailability = true;
          this.action = 'InActive';
          this.associatedUOM = check.item2;
          this.UOMForm.get("statusId").setValue(true);
        } else {
          return;
        }
      })
    }
  }

  checkUOM(parent, child?) {
    const deleteId = (child ? child.id : parent.id);
    this.uomService.checkAssociateUOM(deleteId).subscribe(check => {
      if (check.item1) {
        this.displayUOMAvailability = true;
        this.action = 'Delete';
        this.associatedUOM = check.item2;
      } else {
        this.deleteUOM(parent, child);
      }
    })

  }

  deleteUOM(parent, child?) {
    const deleteId = (child ? child.id : parent.id);
    this.confirmationService.confirm({
      message: 'Do you want to delete this UOM?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.uomService.deleteUOM(deleteId).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          if (child) {
            parent.childUOM.splice(parent.childUOM.findIndex((i) => {
              return i.id === child.id;
            }), 1);
          } else {
            this.allMeasurements.splice(this.allMeasurements.findIndex((i) => {
              return i.id === parent.id;
            }), 1);
          }
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  selectDeselectAll(event) {
    if (event) {
      for (let val of this.conversionLists) {
        val.checked = true;
      }
    } else {
      for (let val of this.conversionLists) {
        val.checked = false;
      }
    }
  }

  eventCalled(uom, action) {
    if(action=='default'){
      uom.isEnable = true;
    }
    this.updateRelatedUOM(uom, action);
  }

  showAddRelatedUOM(c) {
    ////console.log(c);
    this.displayAddUOM2 = true;
    this.isEdit = false;
    this.addrelatedBaseUOM = true;
    this.conversionLists = [];
    this.unitOfConversion = [];
    this.addEditUOMHeader = ObjectNames.productConstants.AddRelatedUOMTitle;
    this.UOMForm.patchValue(c);
    this.baseUOMName = c.name;
    this.uomService.getBaseUOM(c.categoryId, 1, c.id).subscribe(baseUOM => {
      this.relatedUomDD = baseUOM;
      this.relatedUomDD?.splice(this.relatedUomDD?.findIndex((i) => {
        return i.name === c.name;
      }), 1);
      this.relatedUomDD?.splice(this.relatedUomDD?.findIndex((i) => {
        return i.name === ObjectNames.productConstants.AddNewTitle;
      }), 1);
    });
    const filteredCategory = this.UOMTypes.filter(data => data.id == c.categoryId)[0];
    this.UOMForm.controls['categoryId'].setValue(filteredCategory);
    this.UOMForm.controls['statusId'].setValue(c.statusId == Status.ACTIVE ? true : false);
  }

  changeType() {
    if (this.selectedType.name == 'All') {
      this.measurements = this.allMeasurements
    } else {
      this.measurements = this.allMeasurements.filter(e => e.category.name == this.selectedType.name);
    }
  }

  ngOnDestroy(): void {
    this.setupService.setUom('');
  }
}
